import { Injectable } from "@angular/core";

export enum Figures {
  Circle,
  Square,
  HalfCircle,
}

const FigureColors: string[] = [
  "#FA8072",
  "#7FE5F0",
  "#C6CDD2",
  "#657B8B",
  "#042843",
  "#0E5184",
  "#5562FF",
  "#7BC6FF",
  "#98FFF0",
  "#349E8F",
  "#5AEA99",
  "#B0D39A",
  "#9D9D43",
  "#EAEA5A",
  "#FCBE34",
  "#BF7535",
  "#C40000",
  "#FC7171",
  "#FFB5B5",
  "#FF4BC7",
  "#CB7BC2",
  "#910982",
  "#A254FD",
  "#E9C766",
  "#50404D",
  "#93C572",
  "#000080",
  "#008080",
  "#CD9575",
  "#9AB973",
  "#800000",
  "#330DB9",
  "#CF71AF",
  "#BBBBBB",
  "#97A38E",
  "#D97507",
  "#CFAC29",
];
@Injectable({
  providedIn: "root",
})
export class RandomFigureGeneratorService {
  private _figureMapper = {};

  public MapFigureToBuildingGroup(
    buildingGroups: { buildingGroupId: string; figure: string }[]
  ): void {
    this._figureMapper = {};

    buildingGroups.forEach((bg) => {
      if (bg.buildingGroupId == null || bg.figure != null) {
        bg.buildingGroupId == null && this.removeFromFigureMapper(bg);
        return;
      }

      const amountOfExisting = Object.keys(this._figureMapper).length;
      const amountOfShapes = Object.keys(Figures).filter(
        (e: any) => !isNaN(e)
      ).length;
      // total amount of unique shape and color combinations
      const amountOfOptions = FigureColors.length * amountOfShapes;

      // if there are a lot of building groups, it's possible that we're iterating the same shape/color
      // combinations multiple times, so take this into account when determing the shape to use now
      const figureKey = amountOfExisting % amountOfOptions;

      var figureIndex = Math.floor(figureKey / FigureColors.length);
      var colorIndex = figureKey - FigureColors.length * figureIndex;

      var figure = this.generateFigure(colorIndex, figureIndex);

      this._figureMapper[bg.buildingGroupId] = figure;
      buildingGroups.forEach((s) => {
        if (s.buildingGroupId == bg.buildingGroupId) s.figure = figure;
      });
    });
  }

  private removeFromFigureMapper(bg: {
    buildingGroupId: string;
    figure: string;
  }) {
    bg.figure = null;
  }

  private generateFigure(colorIndex: number, figureIndex: number): any {
    var figure = Figures[figureIndex];

    var color = FigureColors[colorIndex];

    return { Figure: figure, Color: color };
  }
}
